import {useEffect, useState} from 'react';

import moment from 'moment';

import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';

import {InvoiceService} from '../hoa-don/InvoiceService';
import {RegisterInvoiceService} from '../../service/invoice/RegisterInvoiceService';

import {useForm} from '../../shared/hooks/Form';
import { TenantClientService } from '../danh-muc/khach-hang/TenantClientService';
import { ToastService } from '../../AppToast';
import {AppStorage} from '../../service/UserStorage';

const periods = [
  {value: 'TODAY', label: 'Hôm nay'},
  {value: 'THISWEEK', label: 'Tuần này'},
  {value: 'THISMONTH', label: 'Tháng này'},
  {value: 'THISFISCALQUARTER', label: 'Quý này'},
  {value: 'THISFISCALYEAR', label: 'Năm nay'},
  {value: 'FIRSTSIXMONTH', label: '6 tháng đầu năm'},
  {value: 'LASTSIXMONTH', label: '6 tháng cuối năm'},
  {value: 'JAN', label: 'Tháng 1'},
  {value: 'FEB', label: 'Tháng 2'},
  {value: 'MAR', label: 'Tháng 3'},
  {value: 'APR', label: 'Tháng 4'},
  {value: 'MAY', label: 'Tháng 5'},
  {value: 'JUN', label: 'Tháng 6'},
  {value: 'JUL', label: 'Tháng 7'},
  {value: 'AUG', label: 'Tháng 8'},
  {value: 'SEP', label: 'Tháng 9'},
  {value: 'OCT', label: 'Tháng 10'},
  {value: 'NOV', label: 'Tháng 11'},
  {value: 'DEC', label: 'Tháng 12'},
  {value: 'FISCALQUARTER1', label: 'Quý I'},
  {value: 'FISCALQUARTER2', label: 'Quý II'},
  {value: 'FISCALQUARTER3', label: 'Quý III'},
  {value: 'FISCALQUARTER4', label: 'Quý IV'},
  {value: 'LASTWEEK', label: 'Tuần trước'},
  {value: 'LASTMONTH', label: 'Tháng trước'},
  {value: 'LASTFISCALQUARTER', label: 'Quý trước'},
  {value: 'LASTFISCALYEAR', label: 'Năm trước'}
];

interface FilterProps {
  header?: any,
  display?: any,
  setDisplay?: any,
  search?: any,
  invoiceForm?: any,
  hiddenFields?: any
}

export const Filter = (props: FilterProps) => {

  const {header, display, setDisplay, search, hiddenFields} = props;

  const [registerInvoices, setRegisterInvoices] = useState([]);
  const [customers, setCustomers] = useState({});
  const [useBuyer, setUseBuyer] = useState(false);
  let userName = AppStorage.get('UserName');
  useEffect(() => {
    setUseBuyer(true);

    RegisterInvoiceService.getUsingList({maxResultCount: 1000,userName, sorting: 'CreationTime', sortType: 'DESCEND'}).then(({items}) => {
      const _registerInvoices = [];
      items.forEach(item => {
        _registerInvoices.push({value: item.symbolCode, label: item.symbolCode});
      });
      setRegisterInvoices(_registerInvoices);
    });
    const _value = getValue();

    if (!_value.period) {
      _value.period = 'THISMONTH';
      setValue(_value);
    }
    if (_value.sendTaxStatus === undefined && !hiddenFields?.includes('sendTaxStatus')) {
      _value.sendTaxStatus = [4];
      setValue(_value);
    }
    if (_value.invoiceStatus === undefined) {
      _value.invoiceStatus = [0,2,3,4,5];
      setValue(_value);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const searchCustomers = by => event => {
    if (by === 'taxCode') {
      if (event.query?.trim()) {
        if (!/^[0-9-]+$/.test(event.query.trim()) || event.query.length > 14) {
          return ToastService.error('Mã số thuế không hợp lệ');
        }
      }
    }
    TenantClientService.getList({[by]: event.query, MaxResultCount: 1000}).then(({items}) => {
      setCustomers(prevState => {
        prevState[by] = items;
        return {...prevState};
      });
    });
  }

  const itemTemplate = (by, setWidth) => (item) => {
    const labels = [];
    if (item[by]) {
      labels.push(item[by]);
    }
    if (item.name) {
      labels.push(item.name);
    }
    if (item.address) {
      labels.push(item.address);
    }
    if (setWidth) {
      if (setWidth.startsWith && setWidth.startsWith('offsetWidth+')) {
        try {
          setWidth = document.getElementById(setWidth.replace('offsetWidth+', '')).offsetWidth;
        } catch (e) {
          setWidth = '50rem';
        }
      }
      return <div style={{width: setWidth, whiteSpace: 'break-spaces', justifyContent:"start"}}>{labels.join(' - ')}</div>
    }
    return labels.join(' - ');
  }

  const {render: renderForm, getValue, setValue} = useForm({
    fields: [
      {field: 'period', header: 'Chọn kỳ', type: 'Dropdown', DropdownProps: {options: periods}, className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'fromDate', header: 'Từ ngày', type: 'Calendar', className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {field: 'toDate', header: 'Đến ngày', type: 'Calendar', className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {
        field: 'buyerTaxCode', header: 'Mã số thuế người mua', className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8', displayDependency(): boolean {
          return hiddenFields?.length && hiddenFields.includes('buyerTaxCode') === false;
        }
      },
      {
        field: 'buyerCode', header: 'Mã khách hàng', className: 'md:col-12',disabled: !useBuyer,
          labelClassName: 'md:col-4', inputClassName: 'md:col-8', type: 'AutoComplete',
          AutoCompleteProps: {suggestions: customers['code'], completeMethod: searchCustomers('code'), field: 'code', itemTemplate: itemTemplate('code', '42rem'), forceSelection: true},
          displayDependency(): boolean {
          return hiddenFields?.length && hiddenFields.includes('buyerCode') === false;
        }
      },
      {field: 'symbol', header: 'Ký hiệu', type: 'MultiSelect', MultiSelectProps: {options: registerInvoices, filter: true}, className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8'},
      {
        field: 'invoiceStatus', header: 'Trạng thái hóa đơn', type: 'MultiSelect', MultiSelectProps: {options: InvoiceService.invoiceStatuses}, className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8', displayDependency(): boolean {
          return hiddenFields?.length && hiddenFields.includes('invoiceStatus') === false;
        }
      },
      {
        field: 'sendTaxStatus', header: 'Trạng thái gửi CQT', type: 'MultiSelect', MultiSelectProps: {options: InvoiceService.sendTaxStatuses}, className: 'md:col-12', labelClassName: 'md:col-4', inputClassName: 'md:col-8', displayDependency(): boolean {
          return hiddenFields?.length && hiddenFields.includes('sendTaxStatus') === false;
        }
      }
    ],
    layout: 'Horizontal',
  });

  const {period} = getValue();
  useEffect(() => {
    if (period) {
      let fromDate = new Date(), toDate = new Date();

      const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
      const quarters = ['FISCALQUARTER1', 'FISCALQUARTER2', 'FISCALQUARTER3', 'FISCALQUARTER4'];
      if (period && months.indexOf(period) >= 0) {
        fromDate = moment().month(months.indexOf(period)).startOf('month').toDate();
        toDate = moment().month(months.indexOf(period)).endOf('month').toDate();
      } else if (period && quarters.indexOf(period) >= 0) {
        fromDate = moment().quarter(quarters.indexOf(period) + 1).startOf('quarter').toDate();
        toDate = moment().quarter(quarters.indexOf(period) + 1).endOf('quarter').toDate();
      } else {
        switch (period) {
          case 'TODAY':
            fromDate = moment().startOf('day').toDate();
            toDate = moment().endOf('day').toDate();
            break;
          case 'THISWEEK':
            fromDate = moment().startOf('isoWeek').toDate();
            toDate = moment().endOf('isoWeek').toDate();
            break;
          case 'THISWEEKTODATE':
            fromDate = moment().startOf('isoWeek').toDate();
            break;
          case 'THISMONTH':
            fromDate = moment().startOf('month').toDate();
            toDate = moment().endOf('month').toDate();
            break;
          case 'THISMONTHTODATE':
            fromDate = moment().startOf('month').toDate();
            break;
          case 'THISFISCALQUARTER':
            fromDate = moment().startOf('quarter').toDate();
            toDate = moment().endOf('quarter').toDate();
            break;
          case 'THISFISCALQUARTERTODATE':
            fromDate = moment().startOf('quarter').toDate();
            break;
          case 'THISFISCALYEAR':
            fromDate = moment().startOf('year').toDate();
            toDate = moment().endOf('year').toDate();
            break;
          case 'THISFISCALYEARTODATE':
            fromDate = moment().startOf('year').toDate();
            break;
          case 'FIRSTSIXMONTH':
            fromDate = moment().startOf('year').toDate();
            toDate = moment().month(5).endOf('month').toDate();
            break;
          case 'LASTSIXMONTH':
            fromDate = moment().month(6).startOf('month').toDate();
            toDate = moment().endOf('year').toDate();
            break;
          case 'YESTERDAY':
            fromDate = moment().subtract(1, 'day').startOf('day').toDate();
            toDate = moment().subtract(1, 'day').endOf('day').toDate();
            break;
          case 'LASTWEEK':
            fromDate = moment().subtract(1, 'week').startOf('isoWeek').toDate();
            toDate = moment().subtract(1, 'week').endOf('isoWeek').toDate();
            break;
          case 'LASTMONTH':
            fromDate = moment().subtract(1, 'month').startOf('month').toDate();
            toDate = moment().subtract(1, 'month').endOf('month').toDate();
            break;
          case 'LASTFISCALQUARTER':
            fromDate = moment().subtract(1, 'quarter').startOf('quarter').toDate();
            toDate = moment().subtract(1, 'quarter').endOf('quarter').toDate();
            break;
          case 'LASTFISCALYEAR':
            fromDate = moment().subtract(1, 'year').startOf('year').toDate();
            toDate = moment().subtract(1, 'year').endOf('year').toDate();
            break;
          case 'NEXTWEEK':
            fromDate = moment().add(1, 'week').startOf('isoWeek').toDate();
            toDate = moment().add(1, 'week').endOf('isoWeek').toDate();
            break;
          case 'NEXTMONTH':
            fromDate = moment().add(1, 'month').startOf('month').toDate();
            toDate = moment().add(1, 'month').endOf('month').toDate();
            break;
          case 'NEXTFISCALQUARTER':
            fromDate = moment().add(1, 'quarter').startOf('quarter').toDate();
            toDate = moment().add(1, 'quarter').endOf('quarter').toDate();
            break;
          case 'NEXTFISCALYEAR':
            fromDate = moment().add(1, 'year').startOf('year').toDate();
            toDate = moment().add(1, 'year').endOf('year').toDate();
            break;
        }
      }
      const _value = getValue();
      _value.fromDate = fromDate;
      _value.toDate = toDate;
      setValue(_value);
    }
  }, [period]); // eslint-disable-line react-hooks/exhaustive-deps

  /** Chỉ lọc theo mã KH khi chọn từ gợi ý; gõ tay không chọn → bỏ khỏi payload */
  const applyBuyerCodeFilter = (_value: ReturnType<typeof getValue>) => {
    if (!_value.buyerCode) return;
    if (typeof _value.buyerCode === 'string') {
      const formValue = getValue();
      formValue.buyerCode = null;
      setValue(formValue);
      delete _value.buyerCode;
      return;
    }
    _value.buyerCode = _value.buyerCode.code;
  };

  const apply = () => {
    const _value = getValue();
    if (_value.symbol) {
      _value.symbol = _value.symbol.join(',');
    }
    if (_value.invoiceStatus) {
      _value.invoiceStatus = _value.invoiceStatus.join(',');
    }
    if (_value.sendTaxStatus) {
      _value.sendTaxStatus = _value.sendTaxStatus.join(',');
    }

    applyBuyerCodeFilter(_value);
    _value.userName = userName;
    search(_value);
  }

  return (
    <Dialog header={header} visible={display} style={{width: '40rem'}} position="top" onHide={() => setDisplay(false)}>

      {renderForm()}

      <div className="flex justify-content-end">
        <Button label="Hủy bỏ" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-text p-button-sm"/>
        <Button label="Nhận" icon="pi pi-check" onClick={apply} className="p-button-sm"/>
      </div>
    </Dialog>
  );
}